/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { Fragment } from 'react'
import { message } from 'antd'
import { Modal } from 'antd-mobile'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import _ from 'lodash'
import { observer } from 'mobx-react'

import TelegramGuide from '@views/TelegramGuide'
import useRootStore from '@store/useRootStore'

// img
import TelegramImg from '@assets/images/icon/telegram/telegram-modal-guide-img.jpg'

// css
import styled from '@themes/theme'
import { ModalBg } from '@styles/base.style'
import { Button, PopupBtnStyle, ButtonWrap, SwitchBtnWrap } from '@styles/button.style'

const TelegramNum = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-top: 1px solid ${props => props.theme.color.modalDarkBg};

  .telegram-input {
    flex: 1;
    height: 30px;
    padding: 0 10px;
    border-radius: 50px;
    text-align: center;
    background: ${props => props.theme.color.modalSubBg2};
    border: none;
    color: ${props => props.theme.color.modalSubTxt};
  }
  .telegram-btn {
    width: 75px;
    height: 30px;
    margin-left: 5px;
    .linkage {
      display: block;
    }
    .cancel {
      display: none;
    }
    /* 텔레그램 번호 입력 완료 후 */
    &.completed {
      background: ${props => props.theme.color.btn};
      .linkage {
        display: none;
      }
      .cancel {
        display: block;
      }
    }
  }
`
const TelegramGuideBtn = css`
  width: 100%;
  height: auto;
  border-radius: 0;
  img {
    width: 100%;
  }
`

const Telegram: React.FC = (): React.ReactElement => {
  const { globalStore, userStore } = useRootStore()
  const { visibleTelegramSetting } = globalStore
  const { userGameOptions } = userStore

  let telegramChatId = userGameOptions.telegramChatId

  const onCloseModal = async () => {
    globalStore.setVisibleTelegramSetting(false)
  }

  const onTelegramChatIdChange = (values: NumberFormatValues) => {
    telegramChatId = values.floatValue
  }

  const onClickConnectTelegramBtn = async () => {
    if (!_.isNumber(telegramChatId)) {
      message.info(['고유번호를 입력하세요.'])
      return
    }

    const result = await userStore.setUserGameOption({ telegramChatId })
    if (result.result === false) {
      message.info(['존재하지 않는 고유 번호입니다. 텔레그램 채널에서 확인해주세요.'])
    } else {
      message.info(['연동 되었습니다.'])
    }
  }

  const onChangeAlarmBettingHit = async e => {
    const elem = e.target as HTMLInputElement
    await userStore.setUserGameOption({ alarmBettingHit: elem.checked })
  }

  const onChangeAlarmNotice = async e => {
    const elem = e.target as HTMLInputElement
    await userStore.setUserGameOption({ alarmNotice: elem.checked })
  }

  const goGuide = () => {
    globalStore.addGeneralPopupProperties(<TelegramGuide/>, '텔레그램 가이드', {
      wrapClassName: '', className: '', isScroll: true, custom: false, clsBtn: false,
    })
  }

  // 연동 or 해제가 필요시 조건에 따라 completed 클래스이름 추가.
  const telegramChatIdBtnClassList = ['telegram-btn']

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleTelegramSetting}
        maskClosable={false}
        onClose={onCloseModal}
        className="custom-dialog"
        title="알림 설정"
      >
        <Button onClick={goGuide} css={TelegramGuideBtn}>
          <img src={TelegramImg} alt="이제 적중알림을 텔레그램으로 편하게 받자. 자세히 보기"/>
        </Button>
        <TelegramNum>
          <NumberFormat
            pattern="\d*"
            decimalScale={0}
            maxLength={50}
            allowNegative={false}
            value={userGameOptions.telegramChatId}
            onValueChange={onTelegramChatIdChange}
            placeholder="고유 번호입력"
            className="telegram-input"
          />
          {/* className: telegram-btn ---> 텔레그램 연동 전 버튼 상태  */}
          {/* className: telegram-btn completed ---> 텔레그램 연동 후 버튼 상태  */}
          <Button secondary className={telegramChatIdBtnClassList.join(' ')} onClick={onClickConnectTelegramBtn}>
            <span className="linkage">연동</span>
            <span className="cancel">해제</span>
          </Button>
        </TelegramNum>

        <SwitchBtnWrap>
          <span className="switch-btn-wrap">
            <p className="switch-btn-wrap--txt">베팅 적중</p>
            <input
              type="checkbox"
              id="hit"
              name="hitAlarmSetting"
              checked={userGameOptions.alarmBettingHit}
              onChange={onChangeAlarmBettingHit}
              className="switch-btn-wrap--btn" /* defaultChecked */
            />
            <label htmlFor="hit" className="on-off-wrap">
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </label>
          </span>
          <span className="switch-btn-wrap">
            <p className="switch-btn-wrap--txt">이벤트, 주요 공지</p>
            <input
              type="checkbox"
              id="event"
              name="eventAlarmSetting"
              checked={userGameOptions.alarmNotice}
              onChange={onChangeAlarmNotice}
              className="switch-btn-wrap--btn" /* defaultChecked */
            />
            <label htmlFor="event" className="on-off-wrap">
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </label>
          </span>
        </SwitchBtnWrap>
        <ButtonWrap className="custom-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} css={PopupBtnStyle} className="one-button">
            확인
          </Button>
        </ButtonWrap>

        <ModalBg onClick={onCloseModal}/>
      </Modal>
    </Fragment>
  )
}

export default observer(Telegram)
